module.exports = __webpack_public_path__ + "img/Neonatology-1.f17168dc.svg";